import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import camelCase from "lodash.camelcase";
import classes from "./images.module.scss";
import Loader from "../../../Components/Common/Loader";
import { Modal } from "../../../shared/Modal/Modal";
import { useLeadImagesQuery } from "../../../api/queries/useLeadImagesQuery";
import { useAppTranslation } from "../../../i18n/useAppTranslation";
import { isObjectInTranslation } from "../../../i18n/utilities";

const LeadsImages = ({ match }) => {
  const { leadID } = match.params;
  const [selectedImage, setSelectedImage] = useState(null);
  const { data: images, isLoading } = useLeadImagesQuery({
    id: Number(leadID),
  });
  const { tLeads } = useAppTranslation.Leads();

  if (isLoading) return <Loader showLoader={true} isFullWidth />;

  const translateLabel = (imageType) => {
    const key = `leadsImages.${camelCase(imageType)}`;
    const translated = tLeads(key);

    if (translated === key || isObjectInTranslation(translated, key)) {
      return imageType;
    }

    return translated;
  };

  return (
    <div id="content">
      <div className="container-fluid content setting-wrapper-leads">
        <div className={`${classes.leadsImagesContainer}`}>
          <h1 className={classes.leadsImagesTitle}>Ageless AI Images</h1>
          <div className={classes.leadsImagesGrid}>
            {(!images || images?.length === 0) && (
              <p className={classes.emptyState}>No images available</p>
            )}
            {images?.map((image, index) => (
              <button
                type="button"
                key={`lead-${leadID}-image-${image.imageType}-${index}`}
                className={classes.imageCard}
                onClick={() => setSelectedImage(image)}
              >
                <span className={classes.thumbWrap}>
                  <img
                    src={image.url}
                    alt={translateLabel(image.imageType)}
                    className={classes.thumb}
                  />
                </span>
                <span className={classes.imageType}>
                  {translateLabel(image.imageType)}
                </span>
              </button>
            ))}
          </div>
        </div>
      </div>
      <Modal
        isOpen={Boolean(selectedImage)}
        onClose={() => setSelectedImage(null)}
        size="wide"
        header={
          selectedImage ? (
            <Modal.Title>{translateLabel(selectedImage.imageType)}</Modal.Title>
          ) : null
        }
        contentClassName={classes.previewModalContent}
      >
        {selectedImage && (
          <img
            src={selectedImage.url}
            alt={translateLabel(selectedImage.imageType)}
            className={classes.previewImage}
          />
        )}
      </Modal>
    </div>
  );
};

export default withRouter(LeadsImages);
